import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions/index";
import sampleCombine from 'xstream/extra/sampleCombine';
import { push } from 'react-router-redux'
import { reset } from 'redux-form/immutable';

export function redirectAfterDeletePersonSuccess(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_PERSON_SUCCESS)
    .map(action => push('/persons'));

  return {
    ACTION: action$,
  }
}

export function requestDeletePerson(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_PERSON)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/people/' + action.payload.id,
      category: 'requestDeletePerson',
      method: 'DELETE',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestDeletePerson')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 204)
    .map(response => actions.deletePersonSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestDeletePersonFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestDeletePerson')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 204)
    .map(response => actions.deletePersonFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function resetPersonFormAfterCreate(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_PERSON_SUCCESS)
    .map(action => reset('login'));

  return {
    ACTION: action$,
  }
}

export function requestResetPassword(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.RESET_PASSWORD)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/people/' + action.payload.id + '/change-password',
      category: 'requestResetPassword',
      method: 'POST',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestResetPassword')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 204)
    .map(response => actions.resetPasswordSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestResetPasswordFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestResetPassword')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 204)
    .map(response => actions.resetPasswordFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function redirectAfterUpdatePersonSuccess(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_PERSON_SUCCESS)
    .map(action => push('/persons'));

  return {
    ACTION: action$,
  }
}

export function requestUpdatePerson(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_PERSON)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/people/' + action.payload.id,
      category: 'requestUpdatePerson',
      method: 'PATCH',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestUpdatePerson')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.updatePersonSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestUpdatePersonFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestUpdatePerson')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.updatePersonFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestPersonById(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_PERSON_BY_ID)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/people/' + action.payload.id + '?filter[include]=roles',
      category: 'requestPersonById',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestPersonById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getPersonByIdSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestPersonByIdFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestPersonById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getPersonByIdFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestCreatePerson(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_PERSON)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/people',
      category: 'requestCreatePerson',
      method: 'POST',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCreatePerson')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.createPersonSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCreatePersonFail(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCreatePerson')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status >= 400)
    .map(response => actions.createPersonFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/person.js